const MAX_RECENT_FONT_FAMILIES = 4;
const STORAGE_KEY = "recentFontFamilies_user";

export const RECENT_FONT_FAMILIES_UPDATED_EVENT = "recentFontFamiliesUpdated";

const dispatchRecentFontsUpdated = (updatedFonts) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(RECENT_FONT_FAMILIES_UPDATED_EVENT, {
    detail: updatedFonts,
  }));
};

export const getRecentFontFamilies = () => {
  try {
    const storedFonts = localStorage.getItem(STORAGE_KEY);
    if (!storedFonts) return [];

    const parsedFonts = JSON.parse(storedFonts);
    return Array.isArray(parsedFonts) ? parsedFonts : [];
  } catch (error) {
    console.warn("Failed to load recent fonts from localStorage:", error);
    return [];
  }
};

export const addRecentFontFamily = (fontFamily) => {
  if (typeof fontFamily !== "string" || !fontFamily.trim()) return null;

  try {
    const trimmedFontFamily = fontFamily.trim();
    const recentFonts = getRecentFontFamilies();
    const filteredFonts = recentFonts.filter((font) => font !== trimmedFontFamily);
    const updatedFonts = [trimmedFontFamily, ...filteredFonts].slice(0, MAX_RECENT_FONT_FAMILIES);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedFonts));
    dispatchRecentFontsUpdated(updatedFonts);
    return updatedFonts;
  } catch (error) {
    console.warn("Failed to save recent font to localStorage:", error);
    return null;
  }
};

export const clearRecentFontFamilies = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    dispatchRecentFontsUpdated([]);
  } catch (error) {
    console.warn("Failed to clear recent fonts from localStorage:", error);
  }
};
